import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Row } from 'react-bootstrap';
import { ProductList } from '../Common/data/Products';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import IconHolder from '../Common/IconHolder';
import { Button, Box } from '@material-ui/core'
import { SESSION_STORAGE_CREATE_CASE, setSessionStorageItem, SESSION_STORAGE_CASE_RETURN_PATH, SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, ILLUSTRATION_PREFILL_DATA, getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../sessionStorage";
import './Products.scss';

export default function Products() {
  window.scrollTo(0, 0);
  const history = useHistory();
  const [productList] = useState(ProductList());
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const isMSEnableDICreateCase = accountObj && accountObj.msEnableDICreateCase;

  const handleCheckToEnableCreateCase = (item) => {
    return (item.name === 'Permanent Life Insurance' || item.name === 'Asset Based/ Hybrid LTC' || (item.name === 'Disability Insurance' && isMSEnableDICreateCase))
  }

  if (ILLUSTRATION_PREFILL_DATA) {
    sessionStorage.removeItem(ILLUSTRATION_PREFILL_DATA);
  }

  const redirectToLandingPage = (key) => {
    history.push(`/Products/Landing/${key}`);
  }

  const onQuoteClick = (path, sessionKey) => {
    if (sessionKey) {
      sessionStorage.removeItem(sessionKey);
    }
    history.push(path);
  }

  const onCreateCaseClick = (sessionkey, name) => {
    if (sessionkey) {
      sessionStorage.removeItem(sessionkey);
    }
    if (name === 'Permanent Life Insurance') {
      setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, "/Products/Landing/perm-insurance")
      const selectedSubmitCaseProduct = {
        submitCaseProductKey: "PERM"
      }
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedSubmitCaseProduct);
    }
    else if (name === 'Disability Insurance') {
      setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, "/Products/Landing/disability-insurance")
      const selectedSubmitCaseProduct = {
        submitCaseProductKey: "DI"
      }
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedSubmitCaseProduct);
    }
    else {
      const selectedSubmitCaseProduct = {
        submitCaseProductKey: "LTC"
      }
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedSubmitCaseProduct);
      setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, "/Products/Landing/ABLTC");
    }
    history.push('/Activity/NewCase/Client')
    return
  }

  return (
    <div className='insurance-products'>
      <div className='breadcrumbs mb-4'>
        <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }]} currentPage={'INSURANCE PRODUCTS'} />
      </div>
      {productList.map((item, index) => {
        return (
          <div className='main-product' key={index}>
            <div
              style={{ backgroundImage: `linear-gradient(150deg, #F9FBFD 0%, #F9FBFD 22%, #F9FBFD00 33%) ,url(${item.imageUrl})` }}
              className='background-image-class'>
              <div className='ml-5'>
                <Row className='mt-5'>
                  <IconHolder icon={item.icon} viewBox="0 0 25 25" />
                </Row>
                <Row className='mt-2'>
                  <Box fontWeight="fontWeightBold" fontSize={20}>
                    {item.name}
                  </Box>
                </Row>
                <Row className='mt-4 mb-4 '>
                  {item.name === 'Traditional Long-Term-Care' || (item.name === 'Disability Insurance' && !isMSEnableDICreateCase) ?
                    <Button color='primary' onClick={() => redirectToLandingPage(item.key)}>PRODUCT DETAIL</Button> :
                    <div>
                      {item.name !== 'Disability Insurance' &&
                        <Button variant="contained" color='primary' onClick={() => onQuoteClick(item.href, item.sessionKey)}>Quick Quote</Button>
                      }
                      {handleCheckToEnableCreateCase(item) &&
                        <Button variant="contained" color="primary" className='ml-3' onClick={() => onCreateCaseClick(SESSION_STORAGE_CREATE_CASE, item.name)}>Create Case</Button>
                      }
                      <Button className='ml-3' color="primary" onClick={() => redirectToLandingPage(item.key)}>PRODUCT DETAILS</Button>
                    </div>
                  }
                </Row>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/ProductLanding/Products.js